import React from 'react';
import { Instagram, Facebook, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-black pt-16 pb-8 border-t-2 border-brand-lime relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 film-grain z-0" data-id="element-45" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46">
        {/* Massive Wordmark */}
        <div className="mb-16 text-center md:text-left" data-id="element-47">
          <h2 className="font-display text-[60px] md:text-[120px] lg:text-[160px] leading-[0.8] text-brand-soft uppercase tracking-tight" data-id="element-48">
            PRIME NATION
          </h2>
          <p className="text-brand-lime font-mono text-sm md:text-base tracking-widest uppercase mt-4" data-id="element-49">
            Free Essentials. Real Connection.
          </p>
        </div>

        {/* Top Row - 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-50">
          {/* Col 1: Quick Links */}
          <div data-id="element-51">
            <h4 className="text-brand-soft font-mono font-bold tracking-widest uppercase text-[13px] mb-6" data-id="element-52">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-53">
              {['Home', 'About', 'Services', 'Members', 'Careers', 'Gallery', 'Press', 'Contact'].map(link => <li key={link} data-id="element-54">
                  <a href="#" className="text-brand-soft/60 hover:text-brand-lime transition-colors text-sm font-sans" data-id="element-55">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 2: Programs */}
          <div data-id="element-56">
            <h4 className="text-brand-soft font-mono font-bold tracking-widest uppercase text-[13px] mb-6" data-id="element-57">
              Programs
            </h4>
            <ul className="space-y-4" data-id="element-58">
              {['Free Phone', 'Free Tablet', 'Free Internet', 'Free Healthcare', 'Discounted Service'].map(link => <li key={link} data-id="element-59">
                  <a href="#" className="text-brand-soft/60 hover:text-brand-lime transition-colors text-sm font-sans" data-id="element-60">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Contact */}
          <div data-id="element-61">
            <h4 className="text-brand-soft font-mono font-bold tracking-widest uppercase text-[13px] mb-6" data-id="element-62">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-63">
              <li data-id="element-64">
                <a href="mailto:no-reply@primenation.com" className="text-brand-soft/60 hover:text-brand-lime transition-colors text-sm font-sans break-all" data-id="element-65">
                  no-reply@primenation.com
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="text-brand-soft/60 hover:text-brand-lime transition-colors text-sm font-sans" data-id="element-67">
                  Find a Location
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="text-brand-lime font-mono font-bold text-[13px] uppercase tracking-widest hover:text-white transition-colors flex items-center gap-2 mt-6" data-id="element-69">
                  Schedule Appointment <ArrowRight size={16} data-id="element-70" />
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Connect */}
          <div data-id="element-71">
            <h4 className="text-brand-soft font-mono font-bold tracking-widest uppercase text-[13px] mb-6" data-id="element-72">
              Connect
            </h4>

            <div className="flex gap-4 mb-8" data-id="element-73">
              <a href="#" className="w-12 h-12 border-2 border-brand-concrete flex items-center justify-center text-brand-soft hover:border-brand-lime hover:text-brand-lime transition-colors" data-id="element-74">
                <Instagram size={20} data-id="element-75" />
              </a>
              <a href="#" className="w-12 h-12 border-2 border-brand-concrete flex items-center justify-center text-brand-soft hover:border-brand-lime hover:text-brand-lime transition-colors" data-id="element-76">
                <Facebook size={20} data-id="element-77" />
              </a>
            </div>

            <form className="flex flex-col gap-4" onSubmit={e => e.preventDefault()} data-id="element-78">
              <input type="email" placeholder="ENTER YOUR EMAIL" className="w-full bg-transparent border-b-2 border-brand-concrete px-0 py-3 text-brand-soft font-mono text-[13px] tracking-widest placeholder:text-brand-soft/30 focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-79" />
              <button type="submit" className="text-brand-lime font-mono font-bold text-[13px] uppercase tracking-widest hover:text-white transition-colors flex items-center gap-2 w-fit" data-id="element-80">
                JOIN <span className="text-lg leading-none" data-id="element-81">→</span>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Strip */}
        <div className="pt-8 border-t border-brand-concrete flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-82">
          <p className="text-brand-soft/40 font-mono text-xs tracking-widest uppercase" data-id="element-83">
            © 2026 PRIME NATION
          </p>
          <div className="flex gap-6 text-brand-soft/40 font-mono text-xs tracking-widest uppercase" data-id="element-84">
            <a href="#" className="hover:text-brand-lime transition-colors" data-id="element-85">
              TERMS
            </a>
            <a href="#" className="hover:text-brand-lime transition-colors" data-id="element-86">
              PRIVACY
            </a>
          </div>
        </div>
      </div>
    </footer>;
}